import { AppTopNavi } from "@abb/abb-common-ux-react/components/AppTopNavi";
import { MenuItemSelection } from "models/menuItemSelection";
import React, { FC } from "react";
import { NavItem } from "./NavItem";
import { Stack } from '@mui/material';

export interface TopNaviItemsProps {
  menuItems: MenuItemSelection[];
  useExternalLinks: boolean;
  activePath?: string;
  baseUrl: string;
  onClick: (
    internalRoute: string,
    externalRoute: string | null | undefined,
    isLogOut: boolean
  ) => void;
  translateText?: (text: string) => string;
  isMobile:boolean;
}

export const TopNaviItems: FC<TopNaviItemsProps> = ({
  activePath,
  useExternalLinks,
  menuItems,
  baseUrl,
  onClick,
  translateText,
  isMobile
}: TopNaviItemsProps) => {



  return (
    <Stack>
        <AppTopNavi>
          {menuItems.map((menuItem, idx) => {
            return (
              <NavItem
                isMobile={isMobile}
                menuItem={menuItem}
                activePath={activePath}
                useExternalLinks={useExternalLinks}
                onSelect={onClick}
                baseUrl={baseUrl}
                key={idx}
                translateText={translateText}
              />
            );
          })}
        </AppTopNavi>
    </Stack>
  );
};
